// valentine slider js start
$(document).ready(function () {

  $('.block__valentine-wrapper').each(function () {
    const $section = $(this);
    const $top = $section.find('.block__valentine-slick-top-image');
    const $bottom = $section.find('.block__valentine-slick-bottom-images');

    if (!$top.length || !$bottom.length) return;
    if ($top.hasClass('slick-initialized')) return;

    $top.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      infinite: true,
      fade: true,
      asNavFor: $bottom
    });

    $bottom.slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      focusOnSelect: true,
      arrows: false,
      infinite: true,
      centerMode: true, 
      asNavFor: $top,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 5
          }
        }
      ]
    });
  });

});
// valentine slider js end

document.addEventListener('DOMContentLoaded', () => {

  /* ================= CONFIG ================= */
  const BREAKPOINT = 750;
  const SCROLL_DURATION_TAB = 1000;
  const SCROLL_DURATION_CAPTION = 1500;
  const EXTRA_GAP = 12;

  /* ================= RAF HANDLES ================= */
  let tabScrollRAF = null;
  let captionScrollRAF = null;

  /* ================= EASING ================= */
  function easeInOutCubic(t) {
    return t < 0.5
      ? 4 * t * t * t
      : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  /* ================= SMOOTH SCROLL (TAB) ================= */
  function smoothScrollTab(targetY) {
    if (tabScrollRAF) cancelAnimationFrame(tabScrollRAF);

    const startY = window.pageYOffset;
    const diff = targetY - startY;
    let startTime = null;

    function step(time) {
      if (!startTime) startTime = time;
      const progress = Math.min((time - startTime) / SCROLL_DURATION_TAB, 1);

      window.scrollTo(0, startY + diff * easeInOutCubic(progress));

      if (progress < 1) tabScrollRAF = requestAnimationFrame(step);
    }

    tabScrollRAF = requestAnimationFrame(step);
  }

  /* ================= SMOOTH SCROLL (CAPTION) ================= */
  function smoothScrollCaption(targetY) {
    if (captionScrollRAF) cancelAnimationFrame(captionScrollRAF);

    const startY = window.pageYOffset;
    const diff = targetY - startY;
    let startTime = null;

    function step(time) {
      if (!startTime) startTime = time;
      const progress = Math.min((time - startTime) / SCROLL_DURATION_CAPTION, 1);

      window.scrollTo(0, startY + diff * easeInOutCubic(progress));

      if (progress < 1) captionScrollRAF = requestAnimationFrame(step);
    }

    captionScrollRAF = requestAnimationFrame(step);
  }

  /* ================= GET TARGET Y (DYNAMIC HEADER) ================= */
  function getTargetY(el) {
    const header = document.querySelector('#SiteHeader');
    const headerHeight = header
      ? Math.round(header.getBoundingClientRect().height)
      : 0;

    return (
      el.getBoundingClientRect().top +
      window.pageYOffset -
      headerHeight -
      EXTRA_GAP
    );
  }

  /* ================= MOBILE WRAPPER SLICK ================= */
  function initTabContentMobileSlick() {
    $('.tab-content-wrapper').each(function () {
      const $wrapper = $(this);

      if (window.innerWidth < BREAKPOINT) {
        if (!$wrapper.hasClass('slick-initialized')) {
          $wrapper.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            infinite: false,
            adaptiveHeight: true
          });
        }
      } else {
        if ($wrapper.hasClass('slick-initialized')) {
          $wrapper.slick('unslick');
        }
      }
    });
  }

  initTabContentMobileSlick();
  window.addEventListener('resize', initTabContentMobileSlick);

  /* ================= MAIN SECTION ================= */
  document.querySelectorAll('.block__valentine-choose-main').forEach(section => {

    const buttons  = section.querySelectorAll('.tab-btn');
    const contents = section.querySelectorAll('.tab-content');
    const bgBlocks = section.querySelectorAll('.block__backgrond--custom-wrapper');
    const $wrapper = $(section).find('.tab-content-wrapper');
    const scrollEl = section.querySelector('.block__backgrond--heading-custom');

    /* ---------- ACTIVE STATE ---------- */
    function setActiveState(index) {
      buttons.forEach((btn, i) => btn.classList.toggle('active', i === index));

      contents.forEach((content, i) => {
        content.classList.toggle('is-active', i === index);
        content.classList.toggle('is-inactive', i !== index);

        if (i === index) {
          $(content).find('.slick-initialized').slick('setPosition');
        }
      });

      bgBlocks.forEach((b, i) => b.classList.toggle('active', i === index));
    }

    setActiveState(0);

    /* ---------- TAB CLICK ---------- */
    buttons.forEach((btn, index) => {
      btn.addEventListener('click', () => {

        const targetY = getTargetY(scrollEl);

        if (window.innerWidth < BREAKPOINT && $wrapper.hasClass('slick-initialized')) {
          $wrapper.slick('slickGoTo', index);
          smoothScrollTab(targetY);

        } else {
          smoothScrollTab(targetY);
        }

        setActiveState(index);
      });
    });

    /* ---------- SWIPE → TAB SYNC ---------- */
    if ($wrapper.length) {
      $wrapper.on('afterChange', (_, __, current) => {
        if (window.innerWidth < BREAKPOINT) {
          setActiveState(current);
        }
      });
    }

    /* ================= PRODUCT IMAGE SLICKS ================= */
    $(section).find('.valentine-product').each(function () {

      const $product = $(this);
      const $top = $product.find('.block__valentine-slick-top-image');
      const $bottom = $product.find('.block__valentine-slick-bottom-images');

      if (!$top.length || !$bottom.length) return;
      if ($top.hasClass('slick-initialized')) return;

      $top.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: $bottom
      });

      $bottom.slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        focusOnSelect: true,
        infinite: false,
        asNavFor: $top,
        responsive: [
          { breakpoint: 768, settings: { slidesToShow: 5 } }
        ]
      });
    });

  });

  /* ================= CAPTION SCROLL ================= */
  document.querySelectorAll('.block__section-caption').forEach(caption => {
    caption.addEventListener('click', e => {
      e.preventDefault();

      const target =
        caption.closest('.block__valentine-choose-main') ||
        document.querySelector('.block__valentine-choose-main');

      if (!target) return;

      smoothScrollCaption(getTargetY(target));
    });
  });

  /* ================= QUICK ADD LOADER ================= */
  document.addEventListener('click', e => {
    const btn = e.target.closest('.wd-quick-add-to-cart .add-to-cart');
    if (!btn || btn.classList.contains('btn--loading')) return;

    btn.classList.add('btn--loading');
    setTimeout(() => btn.classList.remove('btn--loading'), 1500);
  });

});

/* ===== Sticky Add To Cart bar (mobile) ===== */
(function(){
if(!/\/products\//.test(window.location.pathname)) return;
function init(){
var form=document.querySelector('.product-single__meta form[action*="/cart/add"]')||document.querySelector('form[action*="/cart/add"]');
if(!form) return;
var realBtn=form.querySelector('button[name="add"]');
if(!realBtn||document.getElementById('sticky-atc-bar')) return;
var lang=(document.documentElement.lang||'hr').slice(0,2);
var btnText=lang==='en'?'ADD TO CART':(lang==='sl'?'DODAJ V KOŠARICO':'DODAJ U KOŠARICU');
var titleEl=document.querySelector('.product-single__title, .product__title, h1');
var priceEl=document.querySelector('.product-single__meta .product__price, .product__price, .price-item--regular');
var ogm=document.querySelector('meta[property="og:image"]');
var imgSrc=ogm?ogm.getAttribute('content'):'';
var ratingHtml='';
var rt=document.querySelector('.anka-rating');
if(rt){var spans=rt.querySelectorAll('span');if(spans.length>1){var cnt=(spans[1].textContent||'').split('·');var num=cnt.length>1?cnt[1].trim().split(' ')[0]:'';ratingHtml='<div class="sab-rating"><span class="sab-stars">'+spans[0].textContent.trim()+'</span>'+(num?' <span class="sab-count">('+num+')</span>':'')+'</div>';}}
var st=document.createElement('style');
st.textContent='#sticky-atc-bar .sab-rating{font-size:12px;line-height:1.2;margin:1px 0 2px;color:#1a1a1a;white-space:nowrap}#sticky-atc-bar .sab-stars{letter-spacing:1px}#sticky-atc-bar .sab-count{opacity:.6}html.js-drawer-open #sticky-atc-bar,body.js-drawer-open #sticky-atc-bar,#sticky-atc-bar.sab-hidden{display:none!important}';
document.head.appendChild(st);
var bar=document.createElement('div');
bar.id='sticky-atc-bar';
var imgHtml=imgSrc?'<img class="sab-img" src="'+imgSrc+'" alt="">':'';
bar.innerHTML=imgHtml+'<div class="sab-info"><div class="sab-title">'+(titleEl?titleEl.textContent.trim():'')+'</div>'+ratingHtml+'<div class="sab-price">'+(priceEl?priceEl.textContent.trim():'')+'</div></div><button type="button" class="sab-btn">'+btnText+'</button>';
document.body.appendChild(bar);
bar.querySelector('.sab-btn').addEventListener('click',function(){realBtn.click();});
function drawerOpen(){
var h=document.documentElement.classList,b=document.body.classList;
if(h.contains('js-drawer-open')||b.contains('js-drawer-open')||b.contains('js-drawer-open-cart'))return true;
var d=document.querySelector('#CartDrawer.drawer--is-open, .drawer--right.drawer--is-open, .cart-drawer.is-open, cart-drawer[open], .drawer.is-active');
return !!d;
}
var ticking=false;
function check(){
ticking=false;
if(drawerOpen()||realBtn.disabled){bar.classList.remove('is-visible');bar.classList.add('sab-hidden');return;}
bar.classList.remove('sab-hidden');
var r=realBtn.getBoundingClientRect();
var visible=r.bottom>0&&r.top<(window.innerHeight||document.documentElement.clientHeight);
if(visible){bar.classList.remove('is-visible');}else{bar.classList.add('is-visible');}
}
function onScroll(){if(!ticking){ticking=true;window.requestAnimationFrame(check);}}
window.addEventListener('scroll',onScroll,{passive:true});
window.addEventListener('resize',onScroll,{passive:true});
var mo=new MutationObserver(onScroll);
mo.observe(document.documentElement,{attributes:true,attributeFilter:['class']});
mo.observe(document.body,{attributes:true,attributeFilter:['class']});
['ajaxProduct:added','cart:open','drawerOpen','drawerClose','cart:build'].forEach(function(ev){document.addEventListener(ev,function(){setTimeout(onScroll,50);setTimeout(onScroll,400);});});
check();
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();

/* ===== Sold-out products to bottom of collection grids ===== */
(function(){function sob(){if(!/\/collections\//.test(window.location.pathname))return;var grids=document.querySelectorAll('.grid--uniform');grids.forEach(function(g){var items=Array.prototype.slice.call(g.children).filter(function(c){return c.classList&&c.classList.contains('grid-product');});items.forEach(function(it){if(it.querySelector('.grid-product__tag--sold-out'))g.appendChild(it);});});}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',sob);}else{sob();}})();
